import React from "react";
import _ from "lodash";
import type { MenuProps } from "antd";
import { Dropdown } from "antd";
import moment from "moment";

const Messageitem = (props: {
  userName: string;
  updatedAt: string;
  lastMessage: string;
  hasSeen: boolean;
}) => {
  const items: MenuProps["items"] = [
    {
      key: "1",
      label: <span>Delete</span>,
    },
    {
      key: "2",
      label: <span>Archive</span>,
    },
    {
      key: "3",
      label: <span>Mute</span>,
    },
  ];

  return (
    <div
      className={`p-2 flex cursor-pointer ${!props.hasSeen &&  'bg-appcolorfaintpurplsix/20'}`}
      style={{
        borderRight: "2px solid #7031C0",
        borderRadius: "5px",
        paddingRight: "0.5rem",
      }}
    >
      <div className="mr-[0.75rem]">
        <img
          src="/img/vectors/messagepp.svg"
          alt=""
          className="h-[4.1rem] w-[4.1rem]"
        />
      </div>
      <div className="grow border-b border-appcolorgreyfaintthree pb-3">
        <div className="flex justify-between">
          <div className="grow">
            <p className="mb-[0.5rem] text-base font-medium text-appcolorpurplefaintone">
              {props.userName}
            </p>
            <p className="text-base text-appcolorpurplefaintone">
              {_.truncate(props.lastMessage, {length: 30})}
            </p>
          </div>
          <div className="flex w-[5rem] flex-col items-end justify-between">
            <p className="text-xs">{moment(props.updatedAt).fromNow()}</p>
            <div className="flex justify-end">
              <Dropdown menu={{ items }} placement="bottomRight">
                <img
                  src="/img/vectors/threedots.svg"
                  alt=""
                  className="w-[1.6rem] cursor-pointer"
                />
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Messageitem;
